export const regexpPatterns = {

  // pattern for EMAIL field
  /* RULES: need clarify and change pattern
  /*
  /*
  /*
   */
  email: `^(([^<>()\\[\\]\\\\.,;:\\s@'']+(\\.[^<>()\\[\\]\\\\.,;:\\s@'']+)*)|('.+''))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$`,

  // pattern for PASSWORD field
  /* RULES:
  /* - includes at least one capital letter
  /* - includes at least one number
  /* - should be 6-12 characters long
   */
  password: `^(?=.*?[A-Z])(?=.*?[0-9]).{6,12}$`,

  breakTag: /\r?\n/g,
  comma: /(\d)(?=(\d{3})+(?!\d))/g
};
